import React, { useState, useEffect } from "react";
import { getToken } from '../utils/cookieUtils';
import { useLocation, useNavigate } from "react-router-dom";
import SubscriptionDetails from "../components/SubscriptionDetails";
import BookingDetailGuest from "../components/BookingDetailGuest";

export default function ChefDetail() {
    const [loggedIn, setLoggedIn] = useState();
    let navigate = useNavigate();
    let location=useLocation();

    
    let subcriptionID=(location.state==null)?((localStorage.getItem('plan_id'))?localStorage.getItem('plan_id'):0):location.state;
    let planStatus =localStorage.getItem("plan_status")
    

    const checkLoggedInUser = () => {
        let token = getToken();
        if (token) {
            setLoggedIn(true)
        } else {
            setLoggedIn(false)
        }
    }

    useEffect(() => {
        //console.log(subcriptionID);
        var title = "Booking Detail | CHEF REPUBLIC"
        var desc = "Booking details for Private Chef Services are automatically entered based on selections done on browse chef page. Customer selects the Time slot for the service."
        const titleTag = document.querySelector('title');
        titleTag.innerText = title;
        const metaTitle = document.querySelector("meta[name='title']");
        metaTitle.setAttribute('content',title)
        const metaDescription = document.querySelector("meta[name='description']");
        metaDescription.setAttribute('content',desc)
        const metaTitleOG = document.querySelector("meta[property='og:title']");
        metaTitleOG.setAttribute('content',title)
        const metaDescriptionOG = document.querySelector("meta[property='og:description']");
        metaDescriptionOG.setAttribute('content',desc)
        const metaTitleTwitter = document.querySelector("meta[property='twitter:title']");
        metaTitleTwitter.setAttribute('content',title)
        const metaDescriptionTwitter = document.querySelector("meta[property='twitter:description']");
        metaDescriptionTwitter.setAttribute('content',desc)

        let role = localStorage.getItem("role");
        if (getToken()) {
            if (role === null) {
                navigate("/");
            }
            if (role === "2") {
                navigate("/chef");
            }
        }
        checkLoggedInUser()
    }, []);

    return (

        true ? <SubscriptionDetails customer={true} option={subcriptionID} /> : <BookingDetailGuest customer={true} />
    )
}
